import { render, staticRenderFns } from "./customerQuestions.vue?vue&type=template&id=31bbfd7c&scoped=true&"
import script from "./customerQuestions.vue?vue&type=script&lang=js&"
export * from "./customerQuestions.vue?vue&type=script&lang=js&"
import style0 from "./customerQuestions.vue?vue&type=style&index=0&id=31bbfd7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bbfd7c",
  null
  
)

export default component.exports